(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHero = () => {
    const heroes = document.querySelectorAll('[data-hh-hero], .hh-hero');
    if (!heroes.length) return;

    heroes.forEach((hero) => {
      const animateIn = () => {
        hero.classList.add('hh-hero--ready');
        hero.querySelectorAll('[data-hh-animate]').forEach((el) => el.classList.add('is-in'));
      };

      if (reduceMotion) {
        animateIn();
        return;
      }

      requestAnimationFrame(animateIn);

      const allowMobileVideo = hero.getAttribute('data-hh-video-mobile') === 'true';
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      const video =
        hero.querySelector('.hh-hero__video-wrap video') ||
        hero.querySelector('video.hh-hero__video');

      if (!video) {
        if (hero.querySelector('.hh-hero__video-wrap--embed')) {
          hero.classList.add('hh-hero--playing');
          hero.querySelectorAll('.hh-hero__embed').forEach((frame) => {
            frame.setAttribute('tabindex', '-1');
            frame.setAttribute('inert', '');
            frame.style.pointerEvents = 'none';
          });
        }
        return;
      }

      if (isMobile && !allowMobileVideo) {
        video.pause?.();
        return;
      }

      video.muted = true;
      video.playsInline = true;
      video.controls = false;
      video.removeAttribute('controls');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      const markPlaying = () => hero.classList.add('hh-hero--playing');

      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(markPlaying).catch(() => {
            hero.classList.remove('hh-hero--playing');
          });
        } else {
          markPlaying();
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      video.addEventListener('playing', markPlaying);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero, { once: true });
  } else {
    initHero();
  }

  document.addEventListener('shopify:section:load', initHero);
})();
